import React from 'react'
import PropTypes from 'prop-types'
import { Button, Container, Input } from '@sainsburys-tech/fable'
import { AlertCircle } from '@sainsburys-tech/icons'

import moment from 'moment'
import SignInButton from '../Buttons/SignInButton'
import api from '../../utils/api'
import redirectUser from '../../utils/routeHelper'
import LoadingOverlay from '../LoadingOverlay'
import AlreadySignedInModal from '../AlreadySignedInModal'
import TCsChangedModal from '../TermsAndConditions/TCsChangedModal'
import NewTCsModal from '../TermsAndConditions/NewTCsModal'
import '../../sass/components/signin.scss'

class SignIn extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      gpsLoading: true,
      loading: false,
      gpsError: false,
      selectedSite: null,
      siteLocationError: false,
      noNearbySitesMessage: 'You are not close to any sites',
      showTCsChangedModal: false,
      showTCModal: false,
      TCAccepted: false,
      latitude: null,
      longitude: null,
      acceptTCError: '',
      selectedSiteType: null,
      carRegistrationNumber: '',
      username: null,
      contractorId: null,
      showSuccessBanner: false,
      showFailureBanner: false,
      vehicleRegistration: null,
      vehicleRegFormOpen: false
    }
  }

  componentDidMount() {
    const {
      setHeader,
      history,
      setNearbySites,
      setSignOutHeader
    } = this.props

    setHeader()
    setSignOutHeader(false)
    setNearbySites(null)

    redirectUser(history)

    this.checkLocation()
    api.getUserState()
      .then((result) => {
        const contractor = result?.contractorState?.contractor
        if (contractor) {
          this.setState({ username: contractor.username, contractorId: contractor.id })
        }
      })
    api.getContractorDetails()
      .then((result) => {
        if (result !== null && result.carRegistration !== null) {
          this.setState({ vehicleRegistration: result.carRegistration })
        }
        if (result.carRegistration === null) {
          this.toggleRegForm()
        }
      })
  }

  componentWillReceiveProps(props) {
    if (props.site) {
      this.setState({ selectedSite: props.site.name, selectedSiteType: props.site.siteType })
    }
  }

  checkLocation = () => {
    if (window.navigator.geolocation) {
      window.navigator.geolocation.getCurrentPosition(this.locationSuccess, this.locationError)
    }
  }

  locationError = (error) => {
    const { message } = error
    let msg = message

    if (error.code === 1) {
      msg = 'You need to turn on location services to find your nearest site and sign in'
    }

    // GPS unavailable
    if (error.code === 2) {
      msg = 'GPS is currently unavailable'
    }
    this.setState({
      loading: false, gpsLoading: false, gpsError: true, gpsErrorText: msg, selectedSite: null
    })
  }

  locationSuccess = (location) => {
    this.setState({ gpsError: false, gpsErrorText: '' })
    this.getClosestSites(location.coords.latitude, location.coords.longitude)
  }

  onCarRegistrationNumberChange = (e) => {
    const value = e.target.value.toUpperCase()
    const regex = /^[a-zA-Z0-9]*$/
    if (value.match(regex)) {
      this.setState({ carRegistrationNumber: value })
    }
  }

  renderStatusMessage = (type, message) => {
    if (!message) {
      return null
    }

    return (
      <div
        className={`dsib-signIn__status dsib-signIn__status--${type}`}
        role={type === 'error' ? 'alert' : 'status'}
      >
        <AlertCircle className="dsib-signIn__statusIcon" aria-hidden="true" focusable="false" />
        <span className="dsib-signIn__statusText">{message}</span>
      </div>
    )
  }

  onCarRegistrationNumberChangeValue = (value) => {
    const upperValue = (value || '').toUpperCase()
    const regex = /^[a-zA-Z0-9]*$/
    if (upperValue.match(regex)) {
      this.setState({ carRegistrationNumber: upperValue })
    }
  }

  handleregistration = () => {
    const { setCarRegistrationNumber } = this.props
    const { carRegistrationNumber } = this.state
    if (carRegistrationNumber === '') {
      return
    }
    setCarRegistrationNumber(carRegistrationNumber)
    const carRegistartionDetails = {
      carRegistration: carRegistrationNumber,
    }
    api.updateCarRegistration(carRegistartionDetails).then((res) => {
      if (res) {
        if (res.status === 200) {
          this.setState({ showSuccessBanner: true, vehicleRegistration: carRegistartionDetails.carRegistration, carRegistrationNumber: '' })
        } else {
          this.setState({ showFailureBanner: true, carRegistrationNumber: '' })
        }
        this.toggleRegForm()
        this.forceUpdate()
      }
    })
  }


  getClosestSites = (latitude, longitude) => {
    const { setNearbySites, setChosenSite } = this.props

    this.setState({ latitude, longitude })
    api.getClosestProperties(latitude, longitude)
      .then((res) => {
        setNearbySites(res)
        if (res === null || res === undefined || res.length === 0) {
          setChosenSite(null)
          this.setState({
            loading: false, gpsLoading: false, siteLocationError: true, selectedSite: null
          })
          return
        }
        if (res === 408) {
          this.setState({ loading: false, gpsLoading: false })
          return
        }
        this.setClosestSite(res)
        this.setState({ loading: false, gpsError: false, gpsLoading: false })
      })
      .catch(() => this.setState({
        loading: false, gpsLoading: false, gpsError: true, gpsErrorText: 'An error occurred getting your closest site'
      }))
  }

  setClosestSite = (res) => {
    const {
      site,
      setChosenSite,
      sites
    } = this.props
    const { selectedSite } = this.state

    if (res && (!selectedSite || sites.findIndex(s => s.code === site.code) === -1)) {
      setChosenSite(res[0])
    }
  }

  checkLocationChange = () => {
    this.setState({ loading: true })
    if (window.navigator.geolocation) {
      window.navigator.geolocation.getCurrentPosition(this.onSignInCheckLocationChange, this.locationError)
    }
  }

  onSignInCheckLocationChange = (pos) => {
    const { latitude, longitude } = pos.coords
    this.checkSiteLocationChange(latitude, longitude)
  }

  checkSiteLocationChange = (latitude, longitude) => {
    const { selectedSite } = this.state
    const { setNearbySites, setSignInStatus } = this.props

    api.getClosestProperties(latitude, longitude)
      .then((res) => {
        if (res && res.findIndex(s => s.name === selectedSite) === -1) {
          setNearbySites(res)
          this.setClosestSite(res)

          const status = { hasWarning: true, statusText: 'Your location has changed. Please try again.' }

          setSignInStatus(status)
          this.setState({ loading: false, gpsLoading: false, siteLocationError: true })
          return true
        }
        if (res) {
          this.handleSignIn(latitude, longitude)
        } else {
          this.setState({
            loading: false, gpsLoading: false, siteLocationError: true, selectedSite: null
          })
        }
      })
      .catch(() => this.setState({ gpsLoading: false, gpsError: true, gpsErrorText: 'An error occurred getting your closest site' }))
  }

  checkTCs = async () => {
    const { user } = this.props
    const { latitude, longitude } = this.state

    const mostRecentTCsDate = await api.getLatestTCs()
    const usersLastAcceptedTCs = await api.getUsersLastAcceptedTCs(user.id)
    if (moment(usersLastAcceptedTCs).isBefore(mostRecentTCsDate)) {
      this.setState({ showTCsChangedModal: true, loading: false })
    } else {
      this.setState({ TCAccepted: true })
      this.handleSignIn(latitude, longitude)
    }
  }

  handleSignIn = async (latitude, longitude) => {
    const { selectedSite, TCAccepted } = this.state
    const {
      history, resetSignIn, requestSignIn, site
    } = this.props

    if (selectedSite) {
      resetSignIn()

      if (TCAccepted === false) {
        this.checkTCs()
      } else {
        this.checkLocationStatus()
        if (site.siteType === 'Store' || site.siteType === 'Convenience') {
          history.push('/firepolicy')
        } else {
          this.setState({ loading: false, gpsLoading: false })
          requestSignIn(latitude, longitude)
        }
      }
    }
  }

  checkLocationStatus = () => {
    const {
      gpsError,
      gpsErrorText,
      siteLocationError,
      gpsLoading,
      noNearbySitesMessage,
      selectedSite
    } = this.state

    const { signInStatus } = this.props

    if (gpsError) {
      return this.renderStatusMessage('warning', gpsErrorText)
    }
    if (!gpsLoading && siteLocationError && selectedSite === null) {
      return this.renderStatusMessage('warning', noNearbySitesMessage)
    }
    if (signInStatus !== null && signInStatus.status.hasWarning) {
      return this.renderStatusMessage('warning', signInStatus.status.statusText)
    }

    if (signInStatus !== null && signInStatus.status.hasError) {
      return this.renderStatusMessage('error', signInStatus.status.statusText)
    }

    return null
  }

  toggleRegForm = () => {
    this.setState(prevState => ({
      ...prevState,
      vehicleRegFormOpen: !prevState.vehicleRegFormOpen
    }))
  }

  getFooter = () => (
    <Container as="div" size="xs">
      <div className="dsib-signIn__footer">
        {!this.state.vehicleRegFormOpen && this.state.vehicleRegistration
        && (
        <div className="dsib-signIn__footerItem car-reg-width">
          <div className="dsib-signIn__footerCenter site-name">
            <Container as="div" className="u-font-weight__bold">
              <p className="u-margin-bottom__small">{`Vehicle registration ${this.state.vehicleRegistration}`}</p>
            </Container>
            <div className="custom-text-button" onClick={() => this.toggleRegForm()}>
              Change Vehicle Registration
            </div>
          </div>
        </div>
        )
        }
        { this.state.vehicleRegFormOpen
        && (
        <div className="dsib-signIn__footerItem car-reg-width">
          <Input
            style={{ placeSelf: 'center', marginBottom: '20px' }}
            label="Add vehicle registration (optional)"
            value={this.state.carRegistrationNumber}
            maxLength={10}
            onChange={value => this.onCarRegistrationNumberChangeValue(value)}
            inputProps={{ inputMode: 'text' }}
          />
          <div className="dsib-signIn__footerButtonRow button">
            {!this.state.vehicleRegistration
           && <Button disabled={this.state.carRegistrationNumber === ''} onClick={this.handleregistration} isFullWidth variant="secondary">Add registration</Button>}
            {this.state.vehicleRegistration
           && <Button disabled={this.state.carRegistrationNumber === ''} onClick={this.handleregistration} isFullWidth variant="secondary">Update registration</Button>}
          </div>
        </div>
        )
        }
      </div>
    </Container>
  )

  displaySiteName = () => {
    const { selectedSite, selectedSiteType, gpsError } = this.state
    if (!gpsError) {
      return (
        <Container as="div" className="u-font-weight__bold">
          {selectedSite}
          <p className="u-margin-bottom__small">{`${selectedSiteType ? `(${selectedSiteType})` : ''}`}</p>
        </Container>
      )
    }
    return ''
  }

  notThisSite = () => {
    const { history } = this.props
    this.checkLocation()
    history.push('/MultipleSites')
  }

  enableSignInBtn = () => {
    const {
      gpsError,
      selectedSite
    } = this.state
    const { site } = this.props

    if (site !== null && site.code !== null && !gpsError && selectedSite !== null) {
      return true
    }

    return false
  }

  acceptNewTCs = async () => {
    const { latitude, longitude } = this.state
    const { user, site } = this.props

    this.setState({ loading: true })

    const result = await api.userAcceptedTCs(user.id, site.code)
    if (result === 0) { // successful
      this.setState({ showTCModal: false, TCAccepted: true, loading: false }, () => this.handleSignIn(latitude, longitude))
    } else {
      this.setState({ loading: false, acceptTCError: 'Something went wrong, please try again.' })
    }
  }

  render() {
    const {
      gpsLoading,
      loading,
      showTCsChangedModal,
      showTCModal,
      acceptTCError
    } = this.state

    const {
      signInStatus, resetSignIn, history, user
    } = this.props

    let isLoading = false

    if (gpsLoading || loading) {
      isLoading = true
    }

    return (
      <div>
        <AlreadySignedInModal
          isOpen={signInStatus.status.alreadySignedIn}
          title="Already Signed In"
          details="You are already signed in"
          okClick={() => {
            this.setState({ loading: true })
            resetSignIn()
            redirectUser(history)
          }}
        />
        <TCsChangedModal isOpen={showTCsChangedModal} continueClick={() => this.setState({ showTCsChangedModal: false, showTCModal: true })} />
        <NewTCsModal isOpen={showTCModal} acceptClick={() => this.acceptNewTCs()} error={acceptTCError} close={() => { this.setState({ showTCModal: false }) }} />

        {!isLoading && !signInStatus.loading
          && (
            <Container as="div" className="dsib-signIn__page">
              {this.state.showFailureBanner
              && (
              <div className="signinerrorbanner">
                <div className="errorbanner">
                  Sorry, we can't save your vehicle
                  <br />
                  {' '}
                  registration right now. Please try again.
                </div>
                <button className="crossiconfailure" onClick={() => this.setState({ showFailureBanner: false })}>X</button>
              </div>
              )}
              {this.state.showSuccessBanner
              && (
              <div className="banner">
                <div className="successbanner">Vehicle registration added</div>
                <button className="crossiconsuccess" onClick={() => this.setState({ showSuccessBanner: false })}>X</button>
              </div>
              )}
              <div className="dsib-signIn__layout">
                <div className="dsib-signIn__content u-z-index__1">
                  <SignInButton className="signinbutton" enabled={this.enableSignInBtn()} onClick={this.checkLocationChange} />
                  <div className="maintitle1">Welcome to Sainsbury's</div>
                  <div className="maintitle2">{user.fullName}</div>
                  {this.state.selectedSite && !this.state.gpsError && (
                    <div className="dsib-signIn__siteName site-name">
                      {this.displaySiteName()}
                    </div>
                  )}
                  <div className="dsib-signIn__actions">
                    <div className="custom-text-button" onClick={() => this.notThisSite()}>Switch to a different site</div>
                    <div>
                      {this.checkLocationStatus()}
                    </div>
                    <Button className="signinbutton custom-margin-top" onClick={this.checkLocationChange} variant="primary">Sign in to site</Button>
                    <div>{this.getFooter()}</div>
                  </div>
                </div>
              </div>
            </Container>
          )
        }
        {isLoading
          && <LoadingOverlay text={gpsLoading && 'Locating you...'} />
        }
        {signInStatus.loading && !isLoading
          && <LoadingOverlay text="Signing you in..." />
        }
      </div>
    )
  }
}

SignIn.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
  setHeader: PropTypes.func.isRequired,
  setSignOutHeader: PropTypes.func.isRequired,
  setSignInStatus: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  setNearbySites: PropTypes.func.isRequired,
  setChosenSite: PropTypes.func.isRequired,
  setCarRegistrationNumber: PropTypes.func.isRequired,
  site: PropTypes.shape({
    code: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    distance: PropTypes.number.isRequired,
    siteType: PropTypes.string.isRequired
  }),
  sites: PropTypes.arrayOf(PropTypes.shape({
    code: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    distance: PropTypes.number.isRequired,
    siteType: PropTypes.string.isRequired
  })),
  resetSignIn: PropTypes.func.isRequired,
  requestSignIn: PropTypes.func.isRequired,
  signInStatus: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    status: PropTypes.shape({
      hasWarning: PropTypes.bool.isRequired,
      hasError: PropTypes.bool.isRequired,
      statusText: PropTypes.string
    })
  }).isRequired
}

SignIn.defaultProps = {
  site: null,
  sites: null,
}

export default SignIn
